module.exports = __webpack_public_path__ + "static/media/clock.1dff5126.svg";